import './home.scss'
import logo from '../../images/toddlerHenry.PNG'

export default function Home() {
  return (
    <div id="homepage">
      <img src={logo} alt="Henrys logo"  id="homeImage" />
      <h1>Henry Irvine</h1>
      <h2>a Twin Cities based little man</h2>
    </div>
  )
}
